import validateInput from '../../../../utils/validateInput';

export default function validate(values) {
  const { project_name } = values;

  return {
    project_name: validateInput(project_name, ['required']),
  };
}
